import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useQueryClient } from '@tanstack/react-query';
import { RollbackOutlined } from '@ant-design/icons';

import {
  CustomNotification,
  dialogFunction,
  RibbonButton,
} from 'common/components';
import {
  useCheckOwnerCompanyId,
  useCheckProductAdministrator,
  useRollBackMasterAPL,
} from 'pages/home/ribbon/components/sections/product-apl/hooks';

import {
  toggleReloadGridApl,
  resetReloadGridApl,
} from 'pages/branded-products-apl/controllers/actions';
import gridViewSelectors from 'common/components/grid-view/controllers/selectors';

import { MASTER_APL_NAME } from './constants';

const RollbackToPreviousMasterAplRibbon = () => {
  const dispatch = useDispatch();
  const rollbackMasterAPL = useRollBackMasterAPL();
  const queryClient = useQueryClient();

  const selectedProducts = useSelector(
    gridViewSelectors.makeSelectDetailCurrentITemsSelection()
  );

  const isMasterAPLSelected =
    selectedProducts?.[0]?.aplName === MASTER_APL_NAME;

  const isAdministrator = useCheckProductAdministrator();

  const isOwnerMember = useCheckOwnerCompanyId(
    selectedProducts?.[0]?.ownerCompanyId
  );

  const disableRollbackMasterApl = () => {
    if (selectedProducts.length !== 1) return true;
    if (!isMasterAPLSelected || !isAdministrator || !isOwnerMember) return true;
    return false;
  };
  const isDisabled = disableRollbackMasterApl();

  const handleRollBackToPreviousMasterAPL = () => {
    const params = { aplId: selectedProducts?.[0]?.id };
    rollbackMasterAPL.mutate(params, {
      onSuccess: (result) => {
        if (result?.isSuccess) {
          dispatch(toggleReloadGridApl());
          setTimeout(() => {
            dispatch(resetReloadGridApl());
          }, 200);
          queryClient.invalidateQueries({
            queryKey: ['apl'],
          });
          CustomNotification.success('Roll Back Master APL successfully.');
        } else {
          CustomNotification.error(result?.message || 'Something went wrong!');
        }
      },
      onError: (error) => {
        CustomNotification.error('Something went wrong!');
      },
    });
  };
  const onRollbackMasterAPL = () => {
    dialogFunction({
      type: 'warn',
      content:
        'This will roll back the Master APL to it’s previous version. Are you sure you’d like to continue?',
      onOk: handleRollBackToPreviousMasterAPL,
    });
  };
  return (
    <RibbonButton
      size='small'
      icon={<RollbackOutlined />}
      label={'Roll Back Master APL'}
      onClick={onRollbackMasterAPL}
      disabled={isDisabled}
    />
  );
};

export default RollbackToPreviousMasterAplRibbon;
